import { FC, useCallback, useMemo } from "react";
import Cover from "../../../../utils/assets/images/widget-covers/normalized_cost_widget_cover.svg";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { isBillingAvailableSelector } from "@/store/common/selectors/billing-status/isBillingAvailableSelector";
import { defaultResourceExplorerViewIdSelector } from "@/store/resource-explorer/selectors/all-resource-explorers/defaultResourceExplorerViewIdSelector";
import { WidgetWithREViewDisabledAction } from "@/components/pages/dashboard/components/adding-widget/widget-select/cards/disabled-actions/WidgetWithREViewDisabledAction";
import { WidgetOptionCard } from "@/components/pages/dashboard/components/adding-widget/WidgetOptionCard";
import { dashboardWidgetLabels } from "@/components/pages/dashboard/utils/constants/constants";
import { initiateNormalizedCostWidgetThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/initiateNormalizedCostWidgetThunk";

export const NormalizedCostWidgetCard: FC = () => {
  const dispatch = useAppDispatch();

  const isBillingAvailable = useAppSelector(isBillingAvailableSelector);

  const defaultViewId = useAppSelector(defaultResourceExplorerViewIdSelector);

  const clickHandler = useCallback(() => {
    dispatch(initiateNormalizedCostWidgetThunk());
  }, [dispatch]);

  const disabledAction = useMemo(() => {
    if (!isBillingAvailable) {
      return (
        <WidgetWithREViewDisabledAction
          viewId={defaultViewId}
          available={isBillingAvailable}
        />
      );
    }
  }, [isBillingAvailable, defaultViewId]);

  return (
    <WidgetOptionCard
      title={dashboardWidgetLabels.normalized_cost ?? ""}
      description="Compare actual and normalized cloud costs. This adjusts each month's cost as if it had 30 days."
      onClick={clickHandler}
      disabledAction={disabledAction}
    >
      <img
        src={Cover}
        alt="NormalizedCostWidgetCard"
        style={{ width: "100%" }}
      />
    </WidgetOptionCard>
  );
};
